import React, { useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import BusinessIcon from '@material-ui/icons/Business'
import { useNonProfitCardStyles } from '../non-profit-card.styles'
import { baseURL } from '../../../api'

type NonprofitCardPropsType = {
  externalId?: string
}

export const NonprofitCardImage: React.FC<NonprofitCardPropsType> = ({
  externalId,
}) => {
  const classes = useNonProfitCardStyles()
  const [noImage, setNoImage] = useState<boolean>(false)
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const imageHolderRef = React.useRef<HTMLDivElement>(null)

  // Preload image to handle errors
  React.useEffect(() => {
    if (externalId) {
      setNoImage(false)
      setImageUrl(null)
      setIsLoading(true)
      const img = new Image()
      const url = `${baseURL}/nonprofits/external/image/${externalId}`
      img.src = url
      img.onerror = () => {
        setImageUrl(null)
        setNoImage(true)
        setIsLoading(false)
      }
      img.onload = () => {
        setImageUrl(url)
        setNoImage(false)
        setIsLoading(false)
      }
    } else {
      setImageUrl(null)
      setNoImage(true)
      setIsLoading(false)
    }
  }, [externalId])

  React.useEffect(() => {
    const holder = imageHolderRef.current
    if (!holder) return

    if (imageUrl && !noImage) {
      holder.style.setProperty('--nonprofit-image-url', `url(${imageUrl})`)
    } else {
      holder.style.removeProperty('--nonprofit-image-url')
    }
  }, [imageUrl, noImage])

  return (
    <div
      ref={imageHolderRef}
      className={[
        classes.imgHolder,
        imageUrl && !noImage ? classes.imgHolderWithBackground : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isLoading && (
        <CircularProgress size={24} className={classes.loader} thickness={4} />
      )}
      {noImage && !isLoading && <BusinessIcon className={classes.noImageIcon} />}
    </div>
  )
}
